import { useEffect } from "react";

const SKIP = /\/img\/(icon-|logo|affinity-logo)|\/badges\//;

const mark = (img) => {
  if (img.dataset.ph !== undefined || SKIP.test(img.getAttribute("src") || "")) return;
  img.dataset.ph = "";
  if (img.complete && img.naturalWidth > 0) return;
  img.classList.add("img-loading");
  const done = () => { img.classList.remove("img-loading"); img.classList.add("img-ready"); };
  img.addEventListener("load", done, { once: true });
  img.addEventListener("error", done, { once: true });
};

// Tags every <img> with a soft brand-tinted placeholder until its bytes arrive, so slow connections never see empty tiles.
export const useImagePlaceholders = () => {
  useEffect(() => {
    document.querySelectorAll("img").forEach(mark);
    const mo = new MutationObserver((muts) => {
      for (const m of muts) for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.tagName === "IMG") mark(n); else n.querySelectorAll?.("img").forEach(mark);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);
};
